/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type LotCurrency = "CHF" | "EUR" | "GBP";
export type LotPriceUnit = "daily" | "m2yearly" | "monthly" | "sell" | "sellm2" | "weekly" | "yearly";
import type { FragmentReference } from "relay-runtime";
declare export opaque type lotPriceUnit_product$ref: FragmentReference;
declare export opaque type lotPriceUnit_product$fragmentType: lotPriceUnit_product$ref;
export type lotPriceUnit_product = {|
  +currency: ?LotCurrency,
  +priceUnit: ?LotPriceUnit,
  +offerType: ?string,
  +rentExtra: ?number,
  +$refType: lotPriceUnit_product$ref,
|};
export type lotPriceUnit_product$data = lotPriceUnit_product;
export type lotPriceUnit_product$key = {
  +$data?: lotPriceUnit_product$data,
  +$fragmentRefs: lotPriceUnit_product$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "lotPriceUnit_product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceUnit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rentExtra",
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'fbd7a376685c98754d39ab97023d68f4';

export default node;
